export var valuesTranslationStateType = ["Changed", "InTranslation", "TranslationFinished", "Merged"];
/*

*/ 
//# sourceMappingURL=TranslationStateType.js.map